function resolveOpenGraphImage(buType) {
  if (buType === 'PLATFORM_PARTNER') {
    return 'https://otovoweb.s3.eu-central-1.amazonaws.com/fb_open_graph_no_brand.jpg';
  }
  return 'https://otovoweb.s3.eu-central-1.amazonaws.com/fb_open_graph_otovo.jpg';
}

export default resolveOpenGraphImage;
